import { OnInit, Component, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { CompatibleItemService } from '../services/compatibleitem.service';
import { CategoryService } from '../services/category.service'
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from '../services/alert.service';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { StorageService } from '../services/storage.service';
import jwt_decode from "jwt-decode";
import { Router } from "@angular/router"
import { ProductService } from '../services/product.service';
import { of } from 'rxjs'
import { SpinnerService } from './../services/spinner.service';
import { MsalService } from '@azure/msal-angular';
import { UploadService } from '../services/upload.service';

@Component({
  selector: 'app-compatibleitem',
  templateUrl: './compatibleitem.component.html',
  styleUrls: ['./compatibleitem.component.css']
})
export class CompatibleitemComponent implements OnInit {
  public uniqueNomenclatures = [];
  public categories = [];
  public selectedNomenclature = '';
  public currentlyCompatibleItems = [];
  public username;
  public products = [];

  items = [];
  @ViewChild('addCompatibleItem') elCompatibleItem: ElementRef;
  private route: ActivatedRoute;
  id: number;
  AddShowHide:boolean = true;
  EditShowHide:boolean = true;
  CreateShowHide:boolean = false;
  UpdateShowHide:boolean = false;
  CancelShowHide = false;
  reverse: boolean = false;
  CreationDate: Date;
  CreatedBy: string;
  baseUrl = environment.baseUrl;
  filename: any;
  isShown:boolean = true;
  imagesource: any;
  compatibleitemname: any;
  frmCompatibleItem = new FormGroup({
    Nomenclature: new FormControl('', [Validators.required, Validators.minLength(1)]),
    CompatibleItem: new FormControl('', [Validators.required, Validators.minLength(1)]),
    CompatibleItemName  : new FormControl(''),
    CompatibleImage: new FormControl('', [Validators.required])

  });
  config = {
    id: 'CompatibleItem',
    itemsPerPage: environment.pagination.pagesize,
    currentPage: 0,
    totalItems: 0,
  };  param = environment.pagination;
  // {
  //   SortColumnName :"Modifiedby",
  //   SortOrder :"DESC",
  //   PageSelected:0,
  //   PageSize:2
  // };
  constructor(
              private renderer: Renderer2,
              private _compatibleitemservice: CompatibleItemService,
              private _categoryservice: CategoryService,
              private _alertService: AlertService,
              private _productService: ProductService,
              private router: Router,
              public storage: StorageService,
              private spinner: SpinnerService,private authService: MsalService,
              private _uploadservice: UploadService) {
                // const tokenitems = { ...localStorage };
                // if(tokenitems.TokenInfo != undefined) {
                //     var clienttoken = jwt_decode(JSON.parse(tokenitems.TokenInfo).access_token);
                //     var isAdmin;
                //     var groups;
                //     //console.log('clienttoken');
                //     //console.log(clienttoken);
                //     this.username = clienttoken["unique_name"];
                //     groups = clienttoken["groups"].split(',');

                //     isAdmin = groups.indexOf("GPI-Aces-Admins",0) != -1;
                //     if(!isAdmin){
                //         this.router.navigate(['/accessdenied']);
                //     }
                // }

              }

  ngOnInit() {
    // write GetNomenclatures call that method before getcompatibleitems
    // then map unique nomenclatures to select box
    // map that select box value to model (selectedNomenclature)
    // on change set the value and reset the page info
    // then call getcompatibleItems() which passes in the
    // this.selectednomenclature value with the this.param value
    this.spinner.showSpinner();
    const activeAccount = this.authService.instance.getActiveAccount();
    if (activeAccount) {
      this.username = activeAccount.username;
    }
    this.GetUniqueNomenclatures();
    //console.log({ ...localStorage });
    this.GetCategories();
    this.GetProducts();
    this.spinner.hideSpinner();
  }

  SortOder(sortBy){
    if (this.param.SortOrder === "ASC") {
      this.reverse = !this.reverse;
      this.param.SortOrder = "DESC"
    } else{
      this.param.SortOrder = "ASC"
    }
    this.param.SortColumnName = sortBy;
    this.GetCompatibleItems();
  }
  pageChanged(event){
    this.config.currentPage = event;
    this.param.PageSelected = event;
    this.GetCompatibleItems();
  }
  Cancel(){
    this.spinner.showSpinner();
    this.id = 0;
    this.frmCompatibleItem.setValue({
                                      Nomenclature:"",
                                      CompatibleItem:"",
                                      CompatibleImage: "",
                                      CompatibleItemName: ""});
    this.AddShowHide = true;
    this.EditShowHide = true;
    this.CreateShowHide = false;
    this.UpdateShowHide =false;
    this.CancelShowHide = false;
    this.spinner.hideSpinner();
  }
  GetCompatibleItems(){
    this.spinner.showSpinner();
    this._compatibleitemservice.getCompatibleItemList(this.selectedNomenclature, this.param).subscribe((data: any) =>{
      //console.log("selectedNomenclature");
      //console.log(this.selectedNomenclature);
      //console.log('compatible items');
      var stringified = JSON.stringify(data);
      this.items = JSON.parse(stringified).PagedDataModel;
      this.config.totalItems = JSON.parse(stringified).page.TotalCount;
      //console.log(this.items);

    })
    this.spinner.hideSpinner();
  }

  GetUniqueNomenclatures(){
    //this._productService.getProductList().subscribe((data: any) =>{
    //  //console.log('products');
    //  //console.log(data);
    //  this.products = data;
    //})
    this._compatibleitemservice.getUniqueNomenclatures().subscribe((data: any) =>{
        var stringifiednomenclatures = JSON.stringify(data);
        this.uniqueNomenclatures = JSON.parse(stringifiednomenclatures);
      //console.log("uniquenomenclatures")
        //console.log(this.uniqueNomenclatures);
    })
  }


  GetCategories() {
    this._categoryservice.getProductCategories().subscribe((data: any) => {
      //console.log('categories');
      //console.log(data);
      var stringifiedcategories = JSON.stringify(data);
      this.categories = JSON.parse(stringifiedcategories);

   });
  }
  GetProducts(){
    this._productService.getProductList().subscribe((data: any) =>{
      //console.log('products');
      //console.log(data);
      this.products = data;
    })
  }

Validation(frmCI:FormGroup){
  let invalidfield : String = '';

if (frmCI.invalid) {
    Object.keys(frmCI.controls).forEach((key) => {
        if(frmCI.get(key).invalid == true){
        if (key === "CompatibleItem") {
          if (invalidfield == '') {
              invalidfield = "Please enter Compatible Item" + "<br/>";
          } else {
              invalidfield += "Please enter Compatible Item" + "<br/>";
          }
        }
            // if(invalidfield == ''){
            //     invalidfield = "Please enter " +  key.charAt(0).toUpperCase() + key.substr(1).toLowerCase()+ "<br/>";
            // } else {
            //     invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
            // }
        }
    });
    this._alertService.showError(invalidfield);
  }
}

  AddCompatibleItem(){
    this.spinner.showSpinner();
    this.id = 0;
    this.AddShowHide = false;
    this.EditShowHide = false;
    this.CreateShowHide = true;
    this.UpdateShowHide =false;
    this.CancelShowHide = true;
    this.spinner.hideSpinner();
  }

  EditCompatibleItem(item){
    this.spinner.showSpinner();
    console.log(item);
    this.id = item.Id;
    //console.log(this.id);
    this.CreatedBy = item.CreatedBy;
    this.CreationDate = item.CreationDate;
    this.compatibleitemname = item.CompatibleItemName;
    this.frmCompatibleItem.setValue({
      Nomenclature:item.Nomenclature,
      CompatibleItem: item.CompatibleItem1,
      CompatibleImage:item.CompatibleItemName,
      CompatibleItemName: item.CompatibleItemName
    });

    this.EditShowHide = false;
    this.AddShowHide = false;
    this.CreateShowHide = false;
    this.UpdateShowHide =true;
    this.CancelShowHide = true;

    //console.log(this.EditShowHide);
    //console.log(this.AddShowHide);
    //console.log(this.UpdateShowHide);

    this.spinner.hideSpinner();
  }
  CreateCompatibleItem(files) {
    this.spinner.showSpinner();
    if (this.frmCompatibleItem.invalid) {
      this.Validation(this.frmCompatibleItem);
      this.spinner.hideSpinner();
      return;
    }
    
    this.save(files);

    let CompatibleItemModel = {
      Nomenclature: this.frmCompatibleItem.get('Nomenclature').value,
      CompatibleItem1: this.frmCompatibleItem.get('CompatibleItem').value,
      CreatedBy: this.username,
      CreationDate: new Date(),
      LastModifiedBy: 'na/andrew.navarro',
      LastModificationDate: new Date(),
      CompatibleItemName: this.frmCompatibleItem.get('CompatibleItemName').value,
    }

    let retvalue = this._compatibleitemservice.postCompatibleItem(CompatibleItemModel);
    retvalue.pipe(
      catchError(err => {
        this._alertService.showError("Error while creating record");
        return of(null);
      })).subscribe((value: any) => {
        this.param.SortOrder = "DESC";
      this.GetCompatibleItems();
      this.Cancel();
      this._alertService.showSuccess("Record created successfully");
      })

      this.spinner.hideSpinner();
    }

    UpdateCompatibleItem(files) {
      this.spinner.showSpinner();
      if (this.frmCompatibleItem.invalid) {
        this.Validation(this.frmCompatibleItem);
        this.spinner.hideSpinner();
        return;
      }
      //console.log(this.id);

      if(files[0] != null){
        this.save(files);
      }

      let CompatibleItemModel = {
        id: this.id,
        Nomenclature: this.frmCompatibleItem.get('Nomenclature').value,
        CompatibleItem1: this.frmCompatibleItem.get('CompatibleItem').value,
        CreatedBy: this.CreatedBy,
        CreationDate: new Date(),
        LastModifiedBy: this.username,
        LastModificationDate: new Date(),
        CompatibleitemName: this.frmCompatibleItem.get('CompatibleItemName').value,
      }

      let retvalue = this._compatibleitemservice.putCompatibleItem(CompatibleItemModel);
      retvalue.pipe(
        catchError(err => {
          this._alertService.showError("Error while creating record");
          return of(null);
        })).subscribe((value: any) => {
          this.param.SortOrder = "DESC";
        this.GetCompatibleItems();
        this.Cancel();
        setTimeout("", 1000);
        this._alertService.showSuccess("Record updated successfully");
        })

        this.spinner.hideSpinner();
      }

  //delete compatiple item
  DeleteCompatibleItem(compatibleitemId: number) {
    if (confirm('Are you sure to delete this record ?')) {
      this._compatibleitemservice.deleteCompatibleItem(compatibleitemId).subscribe(
        (data: any) => {
          this._alertService.showSuccess("Deleted successfully");
        },
        err => {
          if (err.status == 400)
            this._alertService.showError("No data exists");
          else
            this._alertService.showError("Bad request");
        }
      );
      this.GetCompatibleItems();
    }
  }

  setFilename(files) {
    if (files[0]) {
      this.filename = files[0].name;
      this.isShown = false;
    }
  }

  save(files) {
    var start = Date.now().toString();
    var timestampSuffix = start.substr(start.length - 4);

    if(this.filename===undefined)
      return;
    const formdata = new FormData();
    var filename ='';


    filename = this.frmCompatibleItem.value.Nomenclature + this.frmCompatibleItem.value.CompatibleItemName + timestampSuffix+  '.jpg';
    if (files[0]) {
      //console.log(files[0].name);

      formdata.append(filename, files[0]);
      //console.log("append" )
    }
    //console.log(filename);
    this.frmCompatibleItem.patchValue({CompatibleItemName: filename});
    //console.log(formdata);
    //console.log(this.frmProduct.value.ProductName);

    this._uploadservice
      .upload(formdata)
      .subscribe(({ path }) => (this.imagesource = path));
    formdata.delete(filename);

    }


}
